import { useCallback, useEffect, useState } from 'react';
import { api } from '../lib/api';
import {
  isTomAssistantMode,
  TOM_ASSISTANT_MODE_UPDATED_EVENT,
  type TomAssistantMode,
} from '../lib/tomAssistantMode';

export function useTomAssistantMode() {
  const [mode, setMode] = useState<TomAssistantMode>('voice');
  const [loading, setLoading] = useState(true);

  const loadMode = useCallback(async () => {
    try {
      const res = await api.get('/settings/tom-assistant-mode');
      const next = res.data?.data?.mode;
      if (isTomAssistantMode(next)) {
        setMode(next);
      } else {
        setMode('voice');
      }
    } catch {
      setMode('voice');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadMode();
  }, [loadMode]);

  useEffect(() => {
    const onUpdated = (event: Event) => {
      const detail = (event as CustomEvent<{ mode?: TomAssistantMode }>).detail;
      if (isTomAssistantMode(detail?.mode)) {
        setMode(detail.mode);
      } else {
        loadMode();
      }
    };
    window.addEventListener(TOM_ASSISTANT_MODE_UPDATED_EVENT, onUpdated);
    return () => window.removeEventListener(TOM_ASSISTANT_MODE_UPDATED_EVENT, onUpdated);
  }, [loadMode]);

  return { mode, loading, isTextMode: mode === 'text', isVoiceMode: mode === 'voice' };
}
